import React, { Component } from "react";
import {
  InputGroup,
  Input,
  Row,
  Col,
  Button,
  Table
} from "reactstrap";

import Collapsible from 'react-collapsible';
import { reduxForm } from 'redux-form'
import { connect } from 'react-redux';
import BlockUi from 'react-block-ui';
import 'react-block-ui/style.css';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { currentDate, customSelectStyles, mapArray } from '../../../lib/common'
import AppConfig from "../../../config/app";
import Moment from "react-moment";
import { storedb } from '../../client/storedb'
import Pagination from "react-js-pagination";
import * as saleDetailConstant from './constants'
import * as saleDetailAaction from './actions'
import DisplayRecordText from "../../controls/_DisplayRecordText"
import CheckboxTreeList from "../../controls/_CheckboxTreeList";
import * as common from '../../../lib/common'
import Select from 'react-select';
class SaleDetailReport extends Component {
  constructor(props) {
    super(props);
    var dbContext = storedb();
    this.state = {
      store_id: dbContext.getStoreId(),
      tuNgay: currentDate().startOf('month'),
      denNgay: currentDate(),
      item: {},
      list: [],
      total_record: 0,
      tong_soLuong: 0,
      tong_doanhThuChuaCK: 0,
      tong_doanhThu: 0,
      tong_diem: 0,
      page: 1,
      per_page: 20,
      multipleValueNVKD: [],
      multipleValueKhoXuat: [],
      treeNvkd: [],
      treeKhoXuat: [],
      loaiDonHang: "",
      trangThai: [],
      selectedOption: null,
      daThanhToan: "",
      listNhomKhachHang: [],
      selectedOptionNhomKhachHang: null,
      listKhachHang: [],
      selectedOptionKhachHang: null,
      keyword: ""
    };
    this.handleDateChange = this.handleDateChange.bind(this);
  }
  handleDateChange(name, e, value) {
    switch (name) {
      case "tuNgay":
        this.setState({ tuNgay: e });
        break;
      case "denNgay":
        this.setState({ denNgay: e });
        break;
    }
  }
  handleSearchChange = (name, e, value) => {
    switch (name) {
      case "keyword":
        this.setState({ keyword: e.target.value });
        break;
      default:
        break;
    }
  }
  handleSelectChange = (name, selectedOption) => {
    switch (name) {
      case "loaiDonHang":
        this.setState({ loaiDonHang: selectedOption.target.value })
        break;
      case "TrangThai":
        this.setState({ trangThai: selectedOption.target.value })
        break;
      case "DaThangToan":
        this.setState({ daThanhToan: selectedOption.target.value })
        break;
      default:
        break;
    }
  }
  handleChangeTrangThai = selectedOption => {
    var multipleValue = [];
    selectedOption.forEach(function (item) {
      multipleValue.push(parseInt(item.value));
    });
    this.setState({ selectedOption, trangThai: multipleValue });
  };
  handleChangeNhomKhachHang = selectedOptionNhomKhachHang => {
    let { selectedOptionKhachHang } = this.state
    if (selectedOptionNhomKhachHang != null) {
      if (selectedOptionNhomKhachHang.value > 0) {
        this.fetchKHByNhom([selectedOptionNhomKhachHang.value])
      }
    } else {
      selectedOptionKhachHang = null
      //load khách hàng theo nvkd
      let { multipleValueNVKD } = this.state
      if (multipleValueNVKD.length > 0) {
        this.fetchKH(multipleValueNVKD);
      }
    }
    this.setState({ selectedOptionNhomKhachHang, selectedOptionKhachHang });
  };
  handleChangeKhachHang = selectedOptionKhachHang => {
    this.setState({ selectedOptionKhachHang });
  };
  onHandleRemoveNvkd = () => {
    this.setState({ multipleValueNVKD: [], selectedOptionKhachHang: null, listKhachHang: [] })
  }
  onHandleChoiceNvkd = (nodesChecked) => {
    var multipleValue = [];
    nodesChecked.forEach(function (item) {
      if (item.value != 0) {
        multipleValue.push(item.value);
      }
    });
    this.setState({ multipleValueNVKD: multipleValue })
    if (multipleValue.length > 0) {
      this.fetchKH(multipleValue);
    } else {
      this.setState({ selectedOptionKhachHang: null, listKhachHang: [] });
    }
  }

  onHandleRemoveKH = () => {
    this.setState({ listKhachHang: [] })
  }
  onHandleRemoveKhoXuat = () => {
    this.setState({ multipleValueKhoXuat: [] })
  }
  onHandleChoiceKhoXuat = (nodesChecked) => {
    var multipleValue = [];
    nodesChecked.forEach(function (item) {
      if (item.value != 0) {
        multipleValue.push(item.value);
      }
    });
    this.setState({ multipleValueKhoXuat: multipleValue })
  }
  fetchKhoXuat = () => {
    const { saleDetailReportKhoXuatRequest } = this.props
    var requestData = {
      store_id: this.state.store_id
    };
    return saleDetailReportKhoXuatRequest(requestData);
  }
  fetchNhomKhachHang = () => {
    const { saleDetailReportNhomKhRequest } = this.props
    var requestData = {
      keyword: '',
      page: 1,
      per_page: 100
    };
    return saleDetailReportNhomKhRequest(requestData, (data) => {
      let listKH = data;
      let { selectedOptionKhachHang } = this.state
      selectedOptionKhachHang = null
      if (listKH && listKH.length === 1) {
        // neu chi co 1 minh no thì thực hiện set luôn nó
        selectedOptionKhachHang = listKH.map((item) => { return { value: item.Id, label: item.Name } })
      };
      this.setState({
        selectedOptionKhachHang,
        listKhachHang: listKH.map((item) => { return { value: item.Id, label: item.Name } })
      });
    });
  }
  fetchNvkd = (quanlys) => {
    const { saleDetailReportNvkdRequest } = this.props
    var requestData = {
      store_id: this.state.store_id,
      userIds: quanlys
    };
    return saleDetailReportNvkdRequest(requestData);
  }
  fetchKH = (nvkds) => {
    const { saleDetailReportKhRequest } = this.props
    var requestData = {
      stores_id: this.state.store_id,
      nvkds: nvkds
    };
    return saleDetailReportKhRequest(requestData);
  }
  fetchKHByNhom = (nhomId) => {
    const { saleDetailReportKhByNhomRequest } = this.props
    var requestData = {
      nvkds: this.state.multipleValueNVKD,
      nhomId: nhomId
    };
    return saleDetailReportKhByNhomRequest(requestData, (data) => {
      let listKH = data;
      let { selectedOptionKhachHang } = this.state
      selectedOptionKhachHang = null
      if (listKH && listKH.length === 1) {
        // neu chi co 1 minh no thì thực hiện set luôn nó
        selectedOptionKhachHang = listKH.map((item) => { return { value: item.Id, label: item.Name } })
      };
      this.setState({
        selectedOptionKhachHang,
        listKhachHang: listKH.map((item) => { return { value: item.Id, label: item.Name } })
      });
    });
  }
  handlePageChange = (pageNumber) => {
    let page = parseInt(pageNumber || 1)
    return this.setState({ page }, this.fetchList);
  }
  fetchList(page) {
    const { saleDetailReportListRequest } = this.props

    var requestData = {
      tu_ngay: this.state.tuNgay ? this.state.tuNgay.format('YYYYMMDD') : '',
      den_ngay: this.state.denNgay ? this.state.denNgay.format('YYYYMMDD') : '',
      loaiDonHang: this.state.loaiDonHang,
      store_id: this.state.store_id,
      listNvkd: this.state.multipleValueNVKD,
      listNhomKh: mapArray(this.state.selectedOptionNhomKhachHang),
      listKH: mapArray(this.state.selectedOptionKhachHang),
      listKhoXuat: this.state.multipleValueKhoXuat,
      trangThai: this.state.trangThai,
      daThanhToan: this.state.daThanhToan,
      keyword: this.state.keyword,
      page: page || this.state.page,
      per_page: this.state.per_page
    }
    return saleDetailReportListRequest(requestData)
  }
  exportXls = () => {
    const { reportExportXlsRequest } = this.props

    var requestData = {
      tu_ngay: this.state.tuNgay ? this.state.tuNgay.format('YYYYMMDD') : '',
      den_ngay: this.state.denNgay ? this.state.denNgay.format('YYYYMMDD') : '',
      loaiDonHang: this.state.loaiDonHang,
      store_id: this.state.store_id,
      listNvkd: this.state.multipleValueNVKD.join(","),
      listNhomKh: mapArray(this.state.selectedOptionNhomKhachHang).join(","),
      listKH: mapArray(this.state.selectedOptionKhachHang).join(","),
      listKhoXuat: this.state.multipleValueKhoXuat.join(","),
      trangThai: this.state.trangThai,
      keyword: this.state.keyword,
      daThanhToan: this.state.daThanhToan || "",
    };
    return reportExportXlsRequest(requestData, (listEXP) => {
      var dataFile = new Blob([listEXP], {
        type: "application/vnd.ms-excel;charset=UTF-8"
      });
      var fileURL = URL.createObjectURL(dataFile);
      var id = 'dlinkExportChiTiet';
      var fileName = "baocao_chitiet.xls";
      var link = document.getElementById(id);
      if (link == null) {
        var a = document.createElement('a');
        a.style = "display:none;";
        a.id = "dlinkExportChiTiet";
        document.body.appendChild(a);
        link = a;
      }
      var filename = prompt("File name", fileName);
      if (filename) {
        link.href = fileURL;
        link.download = filename;
        link.click();
        link.remove();
      }
    });
  }
  search = () => {
    if (this.props.saleDetailReport.listRequesting) {
      return false;
    }
    return this.setState({ page: 1 }, () => {
      this.fetchList(1);
    });
  }
  keyPress = (e) => {
    if (e.keyCode == 13) {
      this.search()
    }
  }
  onChangeItem = (itemPerPage) => {
    this.setState({ per_page: itemPerPage }, () => {
      this.search();
    });
  }
  componentDidMount() {
    this.fetchNvkd();
    this.fetchKhoXuat();
    this.fetchNhomKhachHang();
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.saleDetailReport.type == saleDetailConstant.SALE_DETAIL_REPORT_NVKD_SUCCESS) {
      let { listNV } = nextProps.saleDetailReport;
      if (listNV && listNV.length === 1) {
        // neu chi co 1 minh no thì thực hiện set luôn nó
        const NvkdChecked = listNV.map((item) => { return { value: item.Id } })
        this.onHandleChoiceNvkd(NvkdChecked)
      };
      this.setState({
        treeNvkd: listNV
      });
    }
    else if (nextProps.saleDetailReport.type == saleDetailConstant.SALE_DETAIL_REPORT_KH_SUCCESS) {
      let { listKH } = nextProps.saleDetailReport;
      let { selectedOptionKhachHang } = this.state
      selectedOptionKhachHang = null
      if (listKH && listKH.length === 1) {
        // neu chi co 1 minh no thì thực hiện set luôn nó
        selectedOptionKhachHang = listKH.map((item) => { return { value: item.Id, label: item.Name } })
      };
      this.setState({
        selectedOptionKhachHang,
        listKhachHang: listKH.map((item) => { return { value: item.Id, label: item.Name } })
      });
    }
    else if (nextProps.saleDetailReport.type == saleDetailConstant.SALE_DETAIL_REPORT_KHOXUAT_SUCCESS) {
      let { listKHO } = nextProps.saleDetailReport;
      this.setState({
        treeKhoXuat: listKHO
      });
    }
    else if (nextProps.saleDetailReport.type == saleDetailConstant.SALE_DETAIL_REPORT_LIST_SUCCESS) {
      let { list, item } = nextProps.saleDetailReport;
      this.setState({
        page: item.page,
        per_page: item.per_page,
        total_record: item.total_record,
        tong_soLuong: item.tong_soLuong,
        tong_doanhThuChuaCK: item.tong_doanhThuChuaCK,
        tong_doanhThu: item.tong_doanhThu,
        tong_diem: item.tong_diem,
        list: list
      });
    } else if (nextProps.saleDetailReport.type == saleDetailConstant.SALE_DETAIL_REPORT_NHOMKH_SUCCESS) {
      let { listNhomKh } = nextProps.saleDetailReport;
      this.setState({
        listNhomKhachHang: listNhomKh.map((item) => { return { value: item.NhomKhId, label: item.Ten } })
      });
    }
  }

  render() {
    const {
      list,
      treeNvkd,
      treeKhoXuat,
      selectedOption,
      selectedOptionNhomKhachHang,
      listNhomKhachHang,
      selectedOptionKhachHang,
      listKhachHang
    } = this.state
    const baoCaoTrangThai = [{ value: AppConfig.ORDER_STATUS.HoanThanhNhap, label: AppConfig.ORDER_STATUS.HoanThanhNhapText },
    { value: AppConfig.ORDER_STATUS.DangXuLy, label: AppConfig.ORDER_STATUS.DangXuLyText },
    { value: AppConfig.ORDER_STATUS.HoanThanh, label: AppConfig.ORDER_STATUS.HoanThanhText },
    { value: AppConfig.ORDER_STATUS.Huy, label: AppConfig.ORDER_STATUS.HuyText }
    ];
    const {
      handleSubmit,
      saleDetailReport: {
        listRequesting
      },
    } = this.props
    return (
      <div className="animated fadeIn report">
        <BlockUi tag="div" blocking={listRequesting} >
          <div>
            <Collapsible trigger="Tìm kiếm..." overflowWhenOpen="inherit" open={true}>
              <Row className="report-control">
                <Col sm="2" xs="6" className="mb-2 pr-0 half-left">
                  <InputGroup size="md">
                    <span className="add_date_exs_span">Từ:</span>
                    <DatePicker
                      dateFormat="DD/MM/YYYY"
                      name="tuNgay"
                      placeholder="Từ ngày"
                      selected={this.state.tuNgay}
                      onChange={this.handleDateChange.bind(this, "tuNgay")}
                      required className={"form-control add_date_exs_input"} />
                  </InputGroup>
                </Col>
                <Col sm="2" xs="6" className="mb-2 pr-0 half-right">
                  <InputGroup size="md">
                    <span className="add_date_exs_span">Đến:</span>
                    <DatePicker
                      dateFormat="DD/MM/YYYY"
                      name="denNgay"
                      placeholder="đến ngày"
                      selected={this.state.denNgay}
                      onChange={this.handleDateChange.bind(this, "denNgay")}
                      required className={"form-control add_date_exs_input"} />
                  </InputGroup>
                </Col>
                <Col sm="3" xs="6" className="mb-2 half-left">
                  <InputGroup size="md">
                    <select className="form-control" value={this.state.loaiDonHang} onChange={this.handleSelectChange.bind(this, "loaiDonHang")}>
                      <option value="">Loại đơn hàng</option>
                      <option value={1}>Đơn đặt hàng</option>
                      <option value={2}>Đơn đặt hàng đại lý</option>
                    </select>
                  </InputGroup>
                </Col>
                <Col sm="3" xs="6" className="mb-2 half-right">
                  <InputGroup size="md">
                    <select className="form-control" value={this.state.loaiDonHang} onChange={this.handleSelectChange.bind(this, "DaThangToan")}>
                      <option value="">Thanh Toán</option>
                      <option value={1}>Đã thanh toán</option>
                      <option value={0}>Chưa thanh toán</option>
                    </select>
                  </InputGroup>
                </Col>
                <Col sm="2" className="mb-2">
                  <InputGroup size="md">
                    <Input name="keyword"
                      placeholder="Mã sản phẩm"
                      value={this.state.keyword}
                      onChange={this.handleSearchChange.bind(this, "keyword")}
                      autoComplete="off"
                      onKeyDown={e => this.keyPress(e)} />
                  </InputGroup>
                </Col>
                <Col sm="4" className="mb-2">
                  <InputGroup size="md">
                    <CheckboxTreeList
                      placeholder={`--Nhân viên KD--`}
                      nodes={treeNvkd}
                      isMultiChoice={false}
                      checked={this.state.multipleValueNVKD}
                      onHandleRemove={(item) => this.onHandleRemoveNvkd(item)}
                      onChoice={e => this.onHandleChoiceNvkd(e)}
                    />
                  </InputGroup>
                </Col>
                <Col sm="4" className="mb-2">
                  <Select
                    styles={customSelectStyles}
                    value={selectedOptionNhomKhachHang}
                    onChange={this.handleChangeNhomKhachHang}
                    options={listNhomKhachHang}
                    placeholder="Nhóm khách hàng"
                    className="form-control p-0"
                    isMulti={false}
                    closeMenuOnSelect={true}
                    isClearable={true}
                  />
                </Col>
                <Col sm="4" className="mb-2">
                  <Select
                    styles={customSelectStyles}
                    value={selectedOptionKhachHang}
                    onChange={this.handleChangeKhachHang}
                    options={listKhachHang}
                    placeholder="Khách hàng"
                    className="form-control p-0"
                    isMulti={false}
                    closeMenuOnSelect={true}
                    isClearable={true}
                  />
                </Col>
                <Col sm="4" className="mb-2">
                  <InputGroup size="md">
                    <CheckboxTreeList
                      placeholder={`--Kho xuất--`}
                      nodes={treeKhoXuat}
                      isMultiChoice={false}
                      checked={this.state.multipleValueKhoXuat}
                      onHandleRemove={(item) => this.onHandleRemoveKhoXuat(item)}
                      onChoice={e => this.onHandleChoiceKhoXuat(e)}
                    />
                  </InputGroup>
                </Col>
                <Col sm="4" className="mb-2">
                  <Select
                    styles={customSelectStyles}
                    value={selectedOption}
                    onChange={this.handleChangeTrangThai}
                    options={baoCaoTrangThai}
                    placeholder="Trạng thái"
                    className="form-control p-0"
                    isMulti
                    closeMenuOnSelect={false}
                  />
                </Col>


              </Row>
            </Collapsible>
          </div>
          <div className="w-100 mb-2 mt-2">
            <Button size="md" color="success" className="mr-1" onClick={handleSubmit(this.search)}><i className="fa fa-search"></i> Thống kê</Button>&nbsp;
              <Button size="md" color="primary" className="mr-1" onClick={this.exportXls.bind(this, {})}><i className="fa fa-file-excel-o"></i> Xuất excel</Button>
          </div>
          <div className="mt-2 bg-white">
            <div className="w-100">
              <DisplayRecordText
                itemsCountPerPage={this.state.per_page}
                onChangeItem={this.onChangeItem}
              />
              <Table hover responsive className="table-outline mb-0 d-sm-table table-sm">
                <thead className="thead-default">
                  <tr>
                    <th scope="col" width="50" className="text-center">#</th>
                    <th scope="col" className="text-left">Ngày lập</th>
                    <th scope="col" className="text-left">Mã KH</th>
                    <th scope="col" className="text-left">Khách hàng</th>
                    <th scope="col" width="250" className="text-left">Địa chỉ</th>
                    <th scope="col" className="text-left">Nhân viên KD</th>
                    <th scope="col" className="text-left">Mã thuốc</th>
                    <th scope="col" className="text-left">Tên thuốc</th>
                    <th scope="col" className="text-right">Số lượng</th>
                    <th scope="col" className="text-right">Đơn giá</th>
                    <th scope="col" className="text-right">Điểm</th>
                    <th scope="col" className="text-right">Doanh thu <br /> chưa CK</th>
                    {/* <th scope="col" className="text-right">Chiết khấu</th> */}
                    <th scope="col" className="text-right">Doanh thu <br /> đã CK</th>
                    <th scope="col" className="text-left">Ghi Chú</th>
                    <th scope="col" className="text-left">Số phiếu</th>
                    <th scope="col" className="text-left">Nơi xuất</th>
                    <th scope="col" className="text-left">Ngày giao</th>
                    <th scope="col" className="text-left">Trạng thái</th>
                  </tr>
                </thead>
                <tfoot>
                  <tr>
                    <th scope="col" colSpan="9" className="text-right">
                      Tổng cộng:
                     <span className="text-success">
                        {this.state.tong_soLuong &&
                          this.state.tong_soLuong.toLocaleString("vi-VN",
                            { minimumFractionDigits: 0 })}</span>
                    </th>
                    <th scope="col" className="text-right">
                    </th>
                    <th scope="col" className="text-right">
                      <span className="text-success">
                        {this.state.tong_diem &&
                          this.state.tong_diem.toLocaleString("vi-VN",
                            { minimumFractionDigits: 0 })}</span>
                    </th>
                    <th scope="col" className="text-right">
                      <span className="text-success">
                        {this.state.tong_doanhThuChuaCK &&
                          this.state.tong_doanhThuChuaCK.toLocaleString("vi-VN",
                            { minimumFractionDigits: 0 })} ₫</span>
                    </th>
                    <th scope="col" className="text-right">
                      <span className="text-success">
                        {this.state.tong_doanhThu &&
                          this.state.tong_doanhThu.toLocaleString("vi-VN",
                            { minimumFractionDigits: 0 })} ₫</span>
                    </th>

                    <th scope="col" colSpan="6" className="text-right">
                    </th>
                  </tr>
                </tfoot>
                <tbody>
                  {list && !!list.length && (
                    list.map((res, idx) => (
                      <tr key={idx + 1}>
                        <td className="text-center">{idx + 1}</td>
                        <td className="text-left">{res.NgayLap && <Moment format="HH:mm DD/MM">{`${res.NgayLap}`}</Moment>}</td>
                        <td className="text-left">{res.MaKhachHang}</td>
                        <td className="text-left">{res.TenKhachHang}</td>
                        <td className="text-left">{res.DiaChi}</td>
                        <td className="text-left">{res.TenNhanVien}</td>
                        <td className="text-left">{res.Sku}</td>
                        <td className="text-left">{res.TenHang}</td>
                        <td className="text-right">{parseFloat(res.SoLuong || 0).toLocaleString("vi-VN", { minimumFractionDigits: 0 })} </td>
                        <td className="text-right">{parseFloat(res.GiaBan || 0).toLocaleString("vi-VN", { minimumFractionDigits: 0 })} </td>
                        <td className="text-right">{parseFloat(res.Diem || 0).toLocaleString("vi-VN", { minimumFractionDigits: 0 })} </td>
                        <td className="text-right">{parseFloat(res.DoanhSoChuaCK || 0).toLocaleString("vi-VN", { minimumFractionDigits: 0 })}</td>
                        <td className="text-right">{parseFloat(res.DoanhSoSauCK || 0).toLocaleString("vi-VN", { minimumFractionDigits: 0 })} </td>
                        {/* <td className="text-right">{parseFloat(res.ChietKhau || 0).toLocaleString("vi-VN", { minimumFractionDigits: 0 })}</td> */}
                        <td className="text-left">{res.GhiChu}</td>
                        <td className="text-left">{res.MaDonHang}</td>
                        <td className="text-left">{res.NoiXuat}</td>
                        <td className="text-left">{res.NgayGiao && <Moment format="DD/MM">{`${res.NgayGiao}`}</Moment>}</td>
                        <td className="text-left">
                          {common.getOrdetStatusText(res.TrangThai, true)}
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>

              </Table>
              {this.state.total_record > this.state.per_page && (
                <Pagination
                  activePage={this.state.page}
                  itemsCountPerPage={this.state.per_page}
                  totalItemsCount={this.state.total_record}
                  pageRangeDisplayed={5}
                  onChange={this.handlePageChange}
                />
              )}
            </div>
            <div className="clearfix"></div>
          </div>
        </BlockUi>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  saleDetailReport: state.saleDetailReport,
  client: state.client,
})

const connected = connect(mapStateToProps, {
  saleDetailReportNvkdRequest: saleDetailAaction.saleDetailReportNvkdRequest,
  saleDetailReportKhRequest: saleDetailAaction.saleDetailReportKhRequest,
  saleDetailReportKhoXuatRequest: saleDetailAaction.saleDetailReportKhoXuatRequest,
  saleDetailReportListRequest: saleDetailAaction.saleDetailReportListRequest,
  reportExportXlsRequest: saleDetailAaction.reportExportXlsRequest,
  saleDetailReportNhomKhRequest: saleDetailAaction.saleDetailReportNhomKhRequest,
  saleDetailReportKhByNhomRequest: saleDetailAaction.saleDetailReportKhByNhomRequest
})(SaleDetailReport)

const formed = reduxForm({
  form: 'saleDetailReport',
})(connected)

export default formed;



// WEBPACK FOOTER //
// ./src/views/Reports/SaleDetailReport/SaleDetailReport.js